import en from './en';
import zh from './zh';
import Cookies from 'js-cookie';
import { createI18n } from 'vue-i18n';
function getLocale() {
  let locale = localStorage.getItem('locale');
  if (!locale) {
    locale = Cookies.get('locale');
  }
  if (!locale) {
    locale = 'zh-CN'; // 默认值
  }
  return locale;
}

const messages = {
  'en': en,
  'zh-CN': zh,
};

const i18nConfig =createI18n( {
  locale: getLocale(),
  fallbackLocale: 'zh-CN',
  messages,
});
// 这里不直接创建 i18n 实例，而是导出配置对象
export default i18nConfig